import { render, staticRenderFns } from "./dedicatedAssistant.vue?vue&type=template&id=dca47538&scoped=true"
import script from "./dedicatedAssistant.vue?vue&type=script&lang=js"
export * from "./dedicatedAssistant.vue?vue&type=script&lang=js"
import style0 from "./dedicatedAssistant.vue?vue&type=style&index=0&id=dca47538&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca47538",
  null
  
)

export default component.exports